export default {
	methods: {
		getLightenDarkenColor(col, amt) {

			var usePound = false;

			if (col[0] == "#") {
				col = col.slice(1);
				usePound = true;
			}

			var num = parseInt(col, 16);

			var r = (num >> 16) + amt;

			if (r > 255) r = 255;
			else if (r < 0) r = 0;

			var b = ((num >> 8) & 0x00FF) + amt;

			if (b > 255) b = 255;
			else if (b < 0) b = 0;

			var g = (num & 0x0000FF) + amt;

			if (g > 255) g = 255;
			else if (g < 0) g = 0;

			return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);

		},
		arrayHas(array, element) {
			if (array.length === 0) {
				return false;
			}
			return array.indexOf(element) !== -1;
		},
		downloadFile(path, fileName) {
			var link = document.createElement('a');
			var href = "http://" + localStorage.env + ".roasup.com" + path;
			link.setAttribute('href', href);
			link.setAttribute('download', fileName);
			link.click();
			//delete link;
		},
		/* copyToClipboard = str => {
			const el = document.createElement('textarea');
			el.value = str;
			el.setAttribute('readonly', '');
			el.style.position = 'absolute';
			el.style.left = '-9999px';
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
		} */
	}
}